import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SizeMenuContent } from './SizeMenuContent';
import { MENU_OPTION_SELECTED, SHOW_PRODUCT_TEMPLATE_EDIT_MODAL } from '../../Rutab/RutabConstants';
import { ImageSelectorDialog } from './ImageSelectorDialog';
import { TextMenuContent } from './TextMenuContent';
import { FormMenuContent } from './FormMenuContent';
import { BackgroundMenuContent } from './BackgroundMenuContent';
import { TypeSelectorDialog } from './TypeSelectorDialog';
import { translate } from "../../Services/translation";
import { useIsCanvasEditingLocked } from '../../Editor/Hooks/useReadOnlyState';
const menuOptions = [
    {
        id: 'Typ',
        label: 'decal.menuoptions.type.label',
        image: '/images/type-icon.svg',
        type: 'Type',
        sideBar: true,
        target: 'type-selector-guide',
    },
    {
        id: 'Form',
        label: 'decal.menuoptions.shape.label',
        image: '/images/category_search.svg',
        type: 'Form',
        sideBar: false,
        target: 'form-selector-guide',
    },
    {
        id: 'Storlek',
        label: 'decal.menuoptions.size.label',
        image: '/images/crop.svg',
        type: 'Size',
        sideBar: false,
        target: 'size-selector-guide',
    },
    {
        id: 'Bakgrund',
        label: 'decal.menuoptions.background.label',
        image: '/images/colors.svg',
        type: 'Background',
        sideBar: false,
        target: 'background-selector-guide',
    },
    {
        id: 'Text',
        label: 'decal.menuoptions.text.label',
        image: '/images/gesture_select.svg',
        type: 'Text',
        sideBar: false,
        target: 'text-button-guide',
    },
    {
        id: 'Bild / symbol',
        label: 'decal.menuoptions.image-icon.label',
        image: '/images/photo_library.svg',
        type: 'Image',
        sideBar: true,
        target: 'image-button-guide',
    },
];
const MenuOptions = memo(({ canvas, canvasRef }) => {
    const isCanvasEditingLocked = useIsCanvasEditingLocked();
    const selectedOption = useSelector((state) => state.decalEditor.menuOption);
    const decalGuide = useSelector((state) => state.decalEditor.decalGuide, (prev, next) => prev === next);
    const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
    const menuItemsRef = useRef([]);
    const dispatch = useDispatch();
    const handleMenuClick = (option, index) => {
        if (isCanvasEditingLocked) {
            dispatch({
                type: SHOW_PRODUCT_TEMPLATE_EDIT_MODAL,
                payload: {
                    showProductTemplateEditModal: true,
                },
            });
            return;
        }
        if (decalGuide !== null) {
            if (decalGuide.stepType !== option.type) {
                return;
            }
            if (option.id === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id)) {
                return;
            }
        }
        if (option.id === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id)) {
            return closeMenu();
        }
        dispatch({
            type: MENU_OPTION_SELECTED,
            payload: { menuOption: option },
        });
        const rect = menuItemsRef.current[index].getBoundingClientRect();
        // Update positioning to account for new layout
        setMenuPosition({
            top: rect.top + window.scrollY,
            left: rect.right + 10,
        });
    };
    const closeMenu = () => {
        dispatch({
            type: MENU_OPTION_SELECTED,
            payload: { menuOption: null },
        });
    };
    const renderMenuContent = () => {
        switch (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.type) {
            case 'Form':
                return _jsx(FormMenuContent, { canvas: canvas, canvasRef: canvasRef });
            case 'Size':
                return _jsx(SizeMenuContent, { canvas: canvas, canvasRef: canvasRef });
            case 'Background':
                return _jsx(BackgroundMenuContent, { canvas: canvas, canvasRef: canvasRef });
            case 'Text':
                return _jsx(TextMenuContent, { canvas: canvas, canvasRef: canvasRef });
            default:
                return null;
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "side-menu", children: _jsx("ul", { className: "menu-items", children: menuOptions.map((option, index) => (_jsxs("li", { onClick: () => handleMenuClick(option, index), ref: (el) => {
                            menuItemsRef.current[index] = el;
                        }, className: option.target, children: [_jsx("div", { className: "icon-circle", children: _jsx("img", { src: option.image, alt: option.label }) }), _jsx("span", { children: translate(option.label) })] }, option.id))) }) }), selectedOption && !(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.sideBar) && (_jsxs("div", { className: "floating-menu", style: { top: menuPosition.top, left: menuPosition.left }, children: [_jsxs("div", { className: "menu-header", children: [_jsx("img", { src: selectedOption.image, alt: translate(selectedOption.label), style: { marginRight: '10px' } }), _jsx("h4", { children: translate(selectedOption.label) })] }), _jsx("div", { className: "menu-content", children: renderMenuContent() })] })), (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.sideBar) && (_jsxs(_Fragment, { children: [(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.type) === 'Type' && (_jsx(TypeSelectorDialog, { canvas: canvas, onClose: closeMenu })), (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.type) === 'Image' && (_jsx(ImageSelectorDialog, { canvas: canvas, onClose: closeMenu }))] }))] }));
});
export default MenuOptions;
